// Showcase Key Outcome Component
// Custom web component for displaying key outcome items

import type { KeyOutcome, TranslatedText } from "./showcase-config.ts";

class ShowcaseKeyOutcome extends HTMLElement {
  private config: KeyOutcome | null = null;

  connectedCallback() {
    this.render();
  }

  setConfig(config: KeyOutcome) {
    this.config = config;
    this.render();
  }

  private getCurrentLang(): string {
    if (typeof globalThis.getInitialLang === "function") {
      return globalThis.getInitialLang();
    }
    return "en";
  }

  private translate(text: TranslatedText): string {
    const lang = this.getCurrentLang();
    return text[lang as keyof TranslatedText] || text.en;
  }

  private render() {
    if (!this.config) return;

    this.innerHTML = `
      <li class="flex items-start gap-2">
        <svg class="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>
        <span class="text-slate-600">
          <span data-en="${this.config.text.en}" data-lv="${this.config.text.lv}" data-it="${this.config.text.it}">
            ${this.translate(this.config.text)}
          </span>
        </span>
      </li>
    `;
  }
}

customElements.define("showcase-key-outcome", ShowcaseKeyOutcome);

export { ShowcaseKeyOutcome };

